import {all, fork} from 'redux-saga/effects'
import generalSaga from './general/sagas'
import audioSaga from './audio/sagas'
import videoSaga from './video/sagas'

export default function* rootSaga() {
  yield all([
    fork(generalSaga),
    fork(audioSaga),
    fork(videoSaga),
  ])
}
